import React from "react";
import { FaInstagram, FaFacebook } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="social-icons">
        <a
          href="https://www.instagram.com/f.d_ventillacie"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram size={25} />
        </a>

        <a
          href="https://www.facebook.com/F.DVentillacie"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook size={25} />
        </a>
      </div>
    </footer>
  );
}

export default Footer;

